"use client";
import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {useNeoContext} from "@/context/neo/neo.context";
import {useForm} from "react-hook-form";
import {BusAttendanceOverview} from "../reports/busAttendanceOverview";
import {CampusAttendanceOverview} from "../reports/campusAttendanceOverview";

interface DASHBOARDREPORTCONFIG {
  reportdata: {
    header: string;
    description: string;
    order: number;
    activeReport?: {
      icon: string;
      menu: string;
      menu_description: string;
      url: string;
      method: string;
      customView?: string;
      filters: any;
      columns?: any;
      activeColumns?: any;
      tabColumns?: Record<string, string[]>;
      dashboardfilter?: any;
      sideBar?: any[] | undefined;
      tabView?: tabView[];
      innerFilters?: any[];
    };
    dashboardfilter?: any;
    menus: {
      icon: string;
      menu: string;
      menu_description: string;
      url: string;
      method: string;
      customView?: string;
      filters: any;
      columns?: any;
      activeColumns?: any;
      tabColumns?: Record<string, string[]>;
    }[];
  };
}

export const DashboardReport: React.FC<DASHBOARDREPORTCONFIG> = ({
  reportdata
}) => {
  const {clients} = useNeoContext();
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: {isSubmitting, errors}
  } = useForm<any>({
    mode: "onChange"
  });

  const handleFilterSubmit = (req: any) => {};

  if (reportdata?.activeReport?.customView === "busAttendanceOverview") {
    return <BusAttendanceOverview reportdata={reportdata} />;
  }

  if (reportdata?.activeReport?.customView === "campusAttendanceOverview") {
    return <CampusAttendanceOverview reportdata={reportdata} />;
  }

  const datas: NeoTableConfig = {
    title: reportdata?.activeReport?.menu
      ? reportdata?.activeReport?.menu
      : "Report",
    table: {
      columns: reportdata?.activeReport?.columns,
      activeColumns: reportdata?.activeReport?.activeColumns,
      activeFilters: reportdata?.activeReport?.filters,
      style: {
        height: "h-full"
      },
      meta: {
        id: 5,
        title: reportdata?.activeReport?.menu
          ? reportdata?.activeReport?.menu
          : "Report",
        description: "Total Data",
        hasSearch: true,
        hasUpload: false,
        hasDownload: true,
        hasAdd: false,
        hasActions: false,
        hasCheckbox: false,
        hasFilter: reportdata?.activeReport?.filters.length ? true : false,
        hasFooter: true,
        hasHeader: true,
        hasPagination: true,
        hasCreate: false
      },
      url: {
        page: {},
        api: {
          get: reportdata?.activeReport?.url
        }
      },
      dashboardfilter: reportdata?.dashboardfilter,
      sidebar: reportdata?.activeReport?.sideBar,
      tabView: reportdata?.activeReport?.tabView,
      tabColumns: reportdata?.activeReport?.tabColumns,
      actions: [],
      innerFilters: reportdata?.activeReport?.innerFilters
    }
  };
  return (
    <>
      <div className="flex min-h-[calc(100vh-63px)]  px-5 py-5">
        {reportdata?.activeReport?.columns.length > 0 && (
          // <NeoTable table={datas.table}></NeoTable>
          <NeoAGgrid table={datas.table}></NeoAGgrid>
        )}
      </div>
    </>
  );
};
